export const domain = 'https://skgamma.info';
